<p-sidebar [(visible)]="visible" position="right" [baseZIndex]="10000" styleClass="user-menu-sidebar" (onHide)="closeSidebar()">
  <div class="user-info-container">
    <div class="userInfo-icon">
      <i class="fa fa-user-circle-o app-orange userIcon" aria-hidden="true"></i>
    </div>
    @if (sessionService.getSession && userProperty.userSelectedCompany) {
      <div class="userInfo-content text-left">
        <h6 class="user-fullname mb-1">{{ sessionService.fullName }}</h6>
        <h6 class="truncate user-email mb-2">
          {{ sessionService.email}}
        </h6>
        <h4 class="user-company mb-3">
          {{ userProperty.userSelectedCompany.name }}
        </h4>
        <a href="javascript:void(0)" class="app-orange d-block mb-2" (click)="navigateToAccountSettings()">{{ "account.my-account" |
          translate }}
        </a>
        @if (canManageAccountSettings) {
          <a href="javascript:void(0)" class="app-orange d-block mb-2" (click)="changePassword()">{{
            "account.changepassword" | translate
            }}
          </a>
        }
      </div>
    }
  </div>

  <!-- Mobile-only: Impersonate actions (hidden on desktop, visible <=900px) -->
  @if (appProperty.impersonateIsActive) {
    <div class="mobile-impersonate-actions">
      @if (appComponent.showTryNewAttendanceSheetButton) {
        <button pButton pRipple icon="pi pi-file-edit"
          label="{{ 'account.try-new-attendance-sheet' | translate }}"
          class="p-button-sm mobile-impersonate-btn"
          (click)="appComponent.openTryNewAttendanceSheet(); closeSidebar()">
        </button>
      }
      <button pButton pRipple [loading]="appComponent.impersonateLoader"
        icon="pi pi-user-minus"
        label="{{ 'account.remove-impersonate' | translate }}"
        class="p-button-sm mobile-impersonate-btn mobile-impersonate-remove"
        (click)="appComponent.removeImpersonate(); closeSidebar()">
      </button>
    </div>
  }

  <!-- Mobile-only: OAuth providers (hidden on desktop, visible <=900px) -->
  @if (appStateHolder.oauthState.providers.length > 0) {
    <div class="mobile-oauth-providers">
      @for (provider of appStateHolder.oauthState.providers; track provider.provider) {
        <div class="mobile-oauth-item"
          [class.oauth-active]="appComponent.getOAuthProviderStatus(provider.provider) === 'active'"
          [class.oauth-expiring]="appComponent.getOAuthProviderStatus(provider.provider) === 'expiring'"
          [class.oauth-expired]="appComponent.getOAuthProviderStatus(provider.provider) === 'expired'"
          (click)="appComponent.showOAuthPanel($event, provider.provider)">
          @if (provider.provider === 'Office365' || provider.provider === 'Microsoft') {
            <img src="assets/CustomIcons/microsoftprovider.svg" class="mobile-oauth-icon" />
            <span class="mobile-oauth-name">Microsoft</span>
          }
          @if (provider.provider === 'Jira' || provider.provider === 'Atlassian') {
            <img src="assets/CustomIcons/jiraprovider.svg" class="mobile-oauth-icon" />
            <span class="mobile-oauth-name">Jira</span>
          }
          <span class="mobile-oauth-status-dot"></span>
        </div>
      }
    </div>
  }

  <div class="companiesSidebar">
    @for (company of userProperty.userCompaniesList; track $index) {
      <div class="row company-row">
        <div class="company-icon-container">
          <i aria-hidden="true" class="fa fa-building-o company-icon"></i>
        </div>
        <div class="company-name-container">
          <label href="javascript:void(0)" 
                (click)="appComponent.changeCompany(company)" 
                class="button-company">
            {{ company.name }}
          </label>
        </div>
      </div>
    }
</div>

<div class="actionButtons">
  <div class="button-account">
    <p-button [raised]="true" pRipple label="{{'account.my-account' | translate}}" styleClass="p-button-secondary"
    (click)="navigateToAccountSettings()"></p-button>
  </div>
  <div class="button-signout">
    <button pButton pRipple label="{{'app.signOut' | translate}}" class="p-button-danger"
    (click)="signOut()"></button>
  </div>
</div>
</p-sidebar>